<c-container class="mt-5">
  <h2>Log Level Switch</h2>
  <c-row class="mb-3">
    <c-col>
      @if (uiState === uiStateEnumForTemplate.ShowData) {
      <form [formGroup]="logLevelForm">
        <mat-form-field appearance="outline" class="flex-66 full-width">
          <mat-label>Log Level</mat-label>
          <mat-select formControlName="logLevel" placeholder="Please select a log level">
            @for (level of logLevels; track level) {
              <mat-option [value]="level">{{ level }}</mat-option>
            }
          </mat-select>
          <mat-error *ngIf="logLevelControl.errors && (logLevelControl.dirty || logLevelControl.touched)">
            Log level is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-66 full-width">
          <mat-label>Target</mat-label>
          <mat-select formControlName="target" placeholder="Please select a target" (selectionChange)="onSelect($event)">
            @for (target of targets; track target) {
              <mat-option [value]="target">{{ target }}</mat-option>
            }
          </mat-select>
          <mat-error *ngIf="targetControl.errors && (targetControl.dirty || targetControl.touched)">
            Target is required
          </mat-error>
          <mat-hint>{{ selectedUrl }}</mat-hint>
        </mat-form-field>
      </form>
      <button class="margin-top-small" mat-raised-button (click)="submit()">Submit</button>
      } @else {
        <mat-spinner class="align-center"></mat-spinner>
      }
    </c-col>
  </c-row>
</c-container>
